export const CURRENCIES = ['USD', 'EUR', 'CAD', 'MXN', 'GBP']
export const CurrencyType = PropTypes.oneOf(CURRENCIES)

export const PriceShape = {
  currency: CurrencyType.isRequired,
  value: PropTypes.number.isRequired,
}
export const PriceType = PropTypes.shape(PriceShape)

export const AttributeShape = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
}
export const AttributeType = PropTypes.shape(AttributeShape)

/**
 * COURSES
 */

export const courseStatus = {
  COMPLETE: 'complete',
  INCOMPLETE: 'incomplete',
  COMING_DUE: 'comingDue',
  PAST_DUE: 'pastDue',
  OPTIONAL: 'optional',
}
export const COURSE_STATUSES = Object.entries(courseStatus).map(([_k, v]) => v)
export const CourseStatusType = PropTypes.oneOf(COURSE_STATUSES)

export const courseViewMode = {
  NORMAL: 1,
  SEQUENTIAL: 2,
}
export const COURSE_VIEW_MODES = Object.entries(courseViewMode).map(([_k, v]) => v)
export const CourseViewModeType = PropTypes.oneOf(COURSE_VIEW_MODES)

export const CourseShape = {
  curriculumId: PropTypes.number.isRequired,
  description: PropTypes.string,
  shortDescription: PropTypes.string,
  dueDate: PropTypes.instanceOf(Date),
  expiresOn: PropTypes.instanceOf(Date),
  courseId: PropTypes.number,
  name: PropTypes.string.isRequired,
  requirementsRegistered: PropTypes.bool,
  forceLinearCompletion: PropTypes.bool,
  sections: PropTypes.any,
  status: CourseStatusType,
  viewMode: CourseViewModeType,
  containsILT: PropTypes.bool,
  platform: PropTypes.string, //?
  length: PropTypes.string, //?
}
export const CourseType = PropTypes.shape(CourseShape)

export const LessonShape = {
  complete: PropTypes.bool,
  curriculumSectionItemId: PropTypes.number,
  description: PropTypes.string,
  framework: PropTypes.oneOf(['scormv12']),
  id: PropTypes.number,
  iltCourse: PropTypes.string,
  isILT: PropTypes.bool,
  name: PropTypes.node,
  objectHash: PropTypes.string,
  objectId: PropTypes.number,
  objectName: PropTypes.oneOf(['Assessment', 'Lesson', 'Classroom']),
  objectTypeId: PropTypes.number,
  required: PropTypes.bool,
  subGroup: PropTypes.number,
}
export const LessonType = PropTypes.shape(LessonShape)

export const SectionShape = {
  complete: PropTypes.bool,
  curriculumSectionId: PropTypes.number,
  description: PropTypes.string,
  items: PropTypes.arrayOf(LessonType),
  minReq: PropTypes.number,
  name: PropTypes.node,
  optional: PropTypes.bool,
  userCurriculumAssignmentId: PropTypes.number,
}
export const SectionType = PropTypes.shape(SectionShape)

/**
 * PRODUCTS
 */

export const ProductShape = {
  sections: PropTypes.any,
  keywords: PropTypes.arrayOf(PropTypes.string),
  thumbnailImage: PropTypes.string,
  bannerImage: PropTypes.string,
  categories: PropTypes.arrayOf(AttributeType),
  platform: AttributeType,
  curriculaIds: PropTypes.arrayOf(PropTypes.number),
  dateCreated: PropTypes.instanceOf(Date),
  dateModified: PropTypes.instanceOf(Date),
  price: PriceType.isRequired,
  purchase: PropTypes.shape({
    orderId: PropTypes.number,
    purchaseDate: PropTypes.instanceOf(Date),
  }),
}
export const ProductType = PropTypes.shape(ProductShape)

export const InstructorLeadProductShape = {
  ...ProductShape,
  date: PropTypes.instanceOf(Date),
  duration: PropTypes.number,
  location: AttributeType,
  seats: PropTypes.shape({
    total: PropTypes.number,
    remaining: PropTypes.number,
  }),
}
export const InstructorLeadProductType = PropTypes.shape(InstructorLeadProductShape)


/**
 * Filters
 */

export const FILTER_TYPES = ['text', 'select', 'multi', 'date-range']

export const CourseFilterShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(FILTER_TYPES),
  key: PropTypes.string,
  getValue: PropTypes.func,
  test: PropTypes.func,
  format: PropTypes.func,
}
export const CourseFilterType = PropTypes.shape(CourseFilterShape)

export const ActiveFilterShape = {
  filterId: PropTypes.string.isRequired,
  activeValue: PropTypes.any,
}
export const ActiveFilterType = PropTypes.shape(ActiveFilterShape)

/**
 * Cart
 */
export const CartItemShape = {
  quantity: PropTypes.number.isRequired,
  dateAdded: PropTypes.instanceOf(Date).isRequired,
  productId: PropTypes.number,
}
export const CartItemType = PropTypes.shape(CartItemShape)

/**
 * Payment
 */

export const PaymentInfoShape = {
  cardNumber: PropTypes.string.isRequired,
  csc: PropTypes.string.isRequired,
  nameOnCard: PropTypes.string.isRequired,
  expiry: PropTypes.string.isRequired,
  address: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  zip: PropTypes.string.isRequired,
}
export const PaymentInfoType = PropTypes.shape(PaymentInfoShape)
